import React from 'react';
import AbstractView from '../../src/components/_views/AbstractView';
import Body from './production/Body';

export default class ProductionDashboard extends AbstractView {
    static pageTitle = 'Dashboards:Production.page-title';

    protected renderContent() {
        return <Body/>;
    }
}
